import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import CupomCadastro, { ICreateCupom } from './CupomCadastro';

import Input from '../../components/Input';
import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';

import ListaCupons, { RefObject } from './ListaCupons';
import { TIPO_USUARIO } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';

export interface IFormBusca {
  codigo?: string;
  parceiro?: string;
}

const Perfil: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ADMINISTRADOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const listaRef = useRef<RefObject>(null);
  const [dadosForm, setDadosForm] = useState<IFormBusca | undefined>(undefined);

  const formRefBusca = useRef<FormHandles>(null);

  const [showModalCadastro, setShowModalCadastro] = useState(false);

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        codigo: Yup.string(),
        parceiro: Yup.string(),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });
      setDadosForm(dados);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  const handleAdd = useCallback((dadosCupom: ICreateCupom) => {
    if (listaRef.current) {
      listaRef.current.addCupom(dadosCupom);
    }
    setShowModalCadastro(false);
  }, []);

  return (
    <Container fluid className="mt-2">
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Perfil"
          handleFecharModal={() => setShowModalCadastro(false)}
          large
        >
          <CupomCadastro addCupom={handleAdd} />
        </Modal>
      )}

      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Perfis</h2>
          <div>
            <Button
              type="button"
              variant="success"
              onClick={() => {
                setShowModalCadastro(true);
              }}
            >
              Novo Cupom
            </Button>
          </div>
        </div>

        <Form ref={formRefBusca} onSubmit={handleSubmitBusca}>
          <div className="row">
            <div className="col-md-4 form-group">
              <Input
                name="codigo"
                label="Código"
                placeholder="CÓDIGO"
                maxLength={45}
                minLength={3}
              />
            </div>
            <div className="col-md-2">
              <Input
                name="parceiro"
                label="Parceiro"
                placeholder="PARCEIRO"
                maxLength={45}
                minLength={3}
              />
            </div>
            <div className="col-md-2">
              <div className="input-group-append mt-3">
                <Button type="submit" variant="secondary-outline">
                  BUSCAR
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="bg-white border p-2">
        <ListaCupons ref={listaRef} dados={dadosForm} />
      </div>
    </Container>
  );
};

export default Perfil;
